import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import { useNotifier } from '../../../context/NotificationContext';

const BulkActionPanel = ({ selectedCount, onBulkAction, selectedIds }) => {
  const notify = useNotifier();
  const [showRejectForm, setShowRejectForm] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const [selectedAction, setSelectedAction] = useState('');

  const handleBulkApprove = () => {
    onBulkAction('approve', selectedIds, 'Bulk approval');
    setSelectedAction('');
  };

  const handleBulkReject = () => {
    if (!rejectReason.trim()) {
      notify.warning('Please provide a reason for bulk rejection');
      return;
    }
    onBulkAction('reject', selectedIds, rejectReason);
    setShowRejectForm(false);
    setRejectReason('');
    setSelectedAction('');
  };

  const handleActionSelect = (action) => {
    setSelectedAction(action);
    if (action === 'reject') {
      setShowRejectForm(true);
    } else if (action === 'approve') {
      handleBulkApprove();
    }
  };

  return (
    <div className="bg-primary-50 border border-primary-200 rounded-lg p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <Icon name="CheckSquare" size={20} className="text-primary" />
          <span className="text-sm font-medium text-primary">
            {selectedCount} biodata selected
          </span>
        </div>

        <div className="flex items-center space-x-3">
          {showRejectForm ? (
            <div className="flex items-center space-x-3">
              <input
                type="text"
                placeholder="Reason for bulk rejection..."
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
                className="input-field w-64 text-sm"
              />
              <button
                onClick={handleBulkReject}
                className="px-4 py-2 bg-error text-white text-sm rounded-md hover:bg-error-600 transition-colors duration-150"
              >
                Confirm Reject
              </button>
              <button
                onClick={() => {
                  setShowRejectForm(false);
                  setRejectReason('');
                  setSelectedAction('');
                }}
                className="px-4 py-2 text-secondary-700 bg-surface border border-secondary-300 text-sm rounded-md hover:bg-secondary-50 transition-colors duration-150"
              >
                Cancel
              </button>
            </div>
          ) : (
            <>
              <button
                onClick={() => handleActionSelect('approve')}
                className="flex items-center space-x-2 px-4 py-2 bg-success text-white text-sm rounded-md hover:bg-success-600 transition-colors duration-150"
              >
                <Icon name="CheckCircle" size={16} />
                <span>Bulk Approve</span>
              </button>
              <button
                onClick={() => handleActionSelect('reject')}
                className="flex items-center space-x-2 px-4 py-2 bg-error text-white text-sm rounded-md hover:bg-error-600 transition-colors duration-150"
              >
                <Icon name="XCircle" size={16} />
                <span>Bulk Reject</span>
              </button>
              <button
                className="flex items-center space-x-2 px-4 py-2 text-secondary-700 bg-surface border border-secondary-300 text-sm rounded-md hover:bg-secondary-50 transition-colors duration-150"
              >
                <Icon name="Download" size={16} />
                <span>Export Selected</span>
              </button>
            </>
          )}
        </div>
      </div>

      {selectedCount > 0 && !showRejectForm && (
        <div className="mt-3 pt-3 border-t border-primary-200">
          <div className="flex items-center justify-between text-sm">
            <div className="flex items-center space-x-4">
              <span className="text-primary-700">Quick Actions:</span>
              <button
                className="text-primary hover:text-primary-700 font-medium"
              >
                Mark as Priority
              </button>
              <button
                className="text-primary hover:text-primary-700 font-medium"
              >
                Assign Reviewer
              </button>
              <button
                className="text-primary hover:text-primary-700 font-medium"
              >
                Add to Batch
              </button>
            </div>
            <button
              onClick={() => onBulkAction('clear', [])}
              className="text-secondary-600 hover:text-secondary-800 font-medium"
            >
              Clear Selection
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BulkActionPanel;